// Identyfikator tagu Google. Formalnie to stary tag UA, ale dane lecą do GA4 przez połączony
// tag witryny — zbieranie działa, więc nie podmieniaj tego w ciemno na "G-...".
const MEASUREMENT_ID = "UA-52324338-3"

let isLoaded = false

// Wołane po zgodzie użytkownika albo na ekranach display (nasz sprzęt) — do tego momentu
// nic się nie ładuje. Flagę ga-disable zerujemy, żeby wcześniejsze odrzucenie nie blokowało display.
export function enableAnalytics() {
  if (!MEASUREMENT_ID) return

  window[`ga-disable-${MEASUREMENT_ID}`] = false

  if (isLoaded) return
  isLoaded = true

  window.dataLayer = window.dataLayer || []
  window.gtag = function () {
    window.dataLayer.push(arguments)
  }

  const script = document.createElement("script")
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`
  document.head.appendChild(script)

  window.gtag("js", new Date())
  window.gtag("config", MEASUREMENT_ID, { anonymize_ip: true })
}

export function disableAnalytics() {
  if (!MEASUREMENT_ID) return

  // Gdyby skrypt był już wczytany w tej sesji (zgoda potem wycofana) — blokujemy wysyłkę.
  window[`ga-disable-${MEASUREMENT_ID}`] = true
  clearAnalyticsCookies()
}

function clearAnalyticsCookies() {
  const names = document.cookie
    .split(";")
    .map((cookie) => cookie.split("=")[0].trim())
    .filter((name) => /^(_ga|_gid|_gat)/.test(name))

  // Cookies GA siedzą na domenie głównej, więc czyścimy też wariant z kropką i bez subdomeny.
  const hostname = window.location.hostname
  const domains = ["", hostname, `.${hostname}`, `.${hostname.split(".").slice(-2).join(".")}`]

  names.forEach((name) => {
    domains.forEach((domain) => {
      const domainPart = domain ? `; domain=${domain}` : ""
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domainPart}`
    })
  })
}
